import { faRectangleList, faUpload } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { makeStyles } from "@material-ui/core/styles";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionSummary,
  Button,
  Card,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import AccordionDetails from "@mui/material/AccordionDetails";
import Checkbox from "@mui/material/Checkbox";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Icon } from "@progress/kendo-react-common";
import axios from "axios";
import { useFormik } from "formik";
import moment from "moment";
import { useAuth } from "oidc-react";
import React, { Fragment, useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import * as Yup from "yup";
import {
  ShowError,
  ShowSucess,
  getUserId,
  getUserRole,
  isJsonArrayString
} from "../../_helper/helper";
import { loadingPanel } from "../../CommonComponents/CommonFunction";
import CoverageEmployeeSign from "./Components/CoverageEmployeeSign";
import companyArray from "./Components/CompanyArray.json";
import Errorlable from "./Components/Errorlable";
import NoticeDetail from "./Components/NoticeDetails";
import { useParams } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    ".&.MuiExpansionPanelSummary-content": {
      padding: 0,
    },
    ".css-sh22l5-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded": {
      minHeight: "32px",
      margin: "0px !important",
    },
    "& .MuiPaper-root": {
      background: "none",
      display: "block",
    },

    margin: "0 !important",
    borderTopWidth: 1,
    borderTopColor: "#ccc",
  },
  asterisk: {
    color: "red !important",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "70%",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
  },
}));

const CoverageMain = () => {
  const classes = useStyles();
  const { EmployeeId } = useParams()

  const plan = {
    Applying: [
      { value: "Member/Employe", label: "Member/Employe" },
      { value: "Spouse", label: "Spouse" },
      { value: "Child", label: "Child" },
    ],
    Zender: [
      { value: "Male", label: "Male" },
      { value: "Female", label: "Female" },
    ],
    Application: [
      { value: "Initial", label: "Initial" },
      { value: " Increase in coverage", label: " Increase in coverage" },
      { value: "Late Application", label: "Late Application" },
    ],
    Application_life: [
      {
        keyLabel: "med_app_life",
        value: "M",
        label: "Life",
        currentamount: "med_app_amount",
        additionalamount: "med_app_add_amount",
        totalamount: "med_app_total_amount",
      },
      {
        keyLabel: "med_app_depe_life",
        value: "D",
        label: "Dependents Life",
        currentamount: "med_app_depe_amount",
        additionalamount: "med_app_depe_add_amount",
        totalamount: "med_app_depe_total_amount",
      },
    ],
    basic_plan: "Basic Life Insurance",
    basic_amount: "10000",
    basic_description: "Basic Life with AD&D $10,000 (Employer Paid) ",

    additional_plan: "Additional/Optional Life Insurance",
    additional_plan_decline: "Decline Additional/Optional Life with AD&D ",
    additional_amount: "10000",
    additional_description: "Basic Life with AD&D $10,000 (Employer Paid) ",
    additional_line1:
      "You may choose one of the following options for yourself:",
    additional_select:
      "Additional/Optional Life with AD&D (Employee Paid) (See Coverage Highlights for bi-weekly age-banded premium rates)",
    additional_amount: [
      { value: 30000, label: "$30,000" },
      { value: 35000, label: "$35,000" },
      { value: 40000, label: "$40,000" },
      { value: 45000, label: "$45,000" },
      { value: 50000, label: "$50,000" },
      { value: 55000, label: "$55,000" },
      { value: 60000, label: "$60,000" },
      { value: 65000, label: "$65,000" },
      { value: 70000, label: "$70,000" },
      { value: 75000, label: "$75,000" },
      { value: 80000, label: "$80,000" },
      { value: 85000, label: "$85,000" },
      { value: 90000, label: "$90,000" },
      { value: 95000, label: "$95,000" },
      { value: 100000, label: "$100,000" },
      { value: 105000, label: "$105,000" },
      { value: 110000, label: "$110,000" },
      { value: 115000, label: "$115,000" },
      { value: 120000, label: "$120,000" },
      { value: 125000, label: "$125,000" },
      { value: 130000, label: "$130,000" },
    ],
    dependents_plan: "Dependents Life Insurance",
    dependents_amount: "18000",
    dependents_decline: "Decline Spouse Life / Child(ren) Life",
    dependents_description:
      "Spouse Life $10,000 / Child(ren) Life $8,000 (Employee Paid) (See Coverage Highlights for bi-weekly premiums)",
  };

  const [medicaldata, setmedicaldata] = useState();

  const getMasterData = () => {
    setLoading(true)
    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
    const payload = {
      tableName: "JA_MedicalHistory_Lookup",
      SearchParams: "",
      columns: "*",
      pageNumber: 1,
      pageSize: 10000000,
      orderBy: "ID",
      sortBy: "",
      orderByMultiple: "",
      limit: 10000000000,
      sortData: "",
      additionalWhere: "",
    };
    axios
      .post(`${newBaseURL}/BenefitAdvanceSearch/Benefits-global`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          Role: getUserRole(userData),
        },
      })
      .then((response) => {
        setmedicaldata(response.data.results);
      })
      .catch((error) => {
        console.warn("Cannot retrieve user data", error);
      }).finally(() => {
        setLoading(false)
      })
  };

  useEffect(() => {
    getMasterData();
  }, []);

  const [errors, setErrors] = useState({});

  // CheckboxChange States
  const [selectedValue, setSelectedValue] = useState(null);
  const [absentCheckbox, setAbsentCheckbox] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [lifevalues, setlifeValues] = useState({
    currentAmount: "",
    additionalAmount: "",
    totalAmount: "",
  });
  const [openCanvas, setOpenCanvas] = useState(false);
  const closeCanvas = () => {
    setOpenCanvas(false);
  }

  // CheckboxChange functions
  const handleCheckboxChange = (value) => {
    setSelectedValue(value);
    setValues({ ...values, "typeofApplication": value })
  };

  const handleCheckboxLifeChange = (
    value,
    currentAmountKey,
    additionalAmountKey,
    totalAmountKey,
    keyLabel
  ) => {
    setValues((prevValues) => ({
      ...prevValues,
      [keyLabel]: value,
    }));
    // setLifecheckbox(value);
    setSelectedValues((prevSelectedValues) => {
      if (prevSelectedValues.includes(value)) {
        // If the checkbox is unchecked, set related form values to empty
        setValues((prevValues) => ({
          ...prevValues,
          [keyLabel]: null, // reset the checkbox value
        }));
        setlifeValues((prevValues) => ({
          ...prevValues,
          [currentAmountKey]: "",
          [additionalAmountKey]: "",
          [totalAmountKey]: "",
        }));
        setFieldValue(currentAmountKey, "");
        setFieldValue(additionalAmountKey, "");
        setFieldValue(totalAmountKey, "");
        return prevSelectedValues.filter((item) => item !== value);
      } else {
        return [...prevSelectedValues, value];
      }
    });
  };

  const handleCheckboxChanges = (id, value) => {
    setAbsentCheckbox((prev) => {
      // Remove the existing item with the same ID and add the new one
      const newState = prev?.filter(item => item.id !== id);
      return [...newState, { id, value }];
    });
  };

  const isChecked = (id, expectedValue) => {
    const item = absentCheckbox?.find(item => item.id === id);
    return item ? item.value === expectedValue : false;
  };


  const [expanded, setExpanded] = React.useState({
    memInfo: true,
    applicantInfo: true,
    appInfo: true,
    phyInfo: true,
    medInfo: true,
    ackInfo: true,
    info: true,
    fraInfo: true,

  });

  const handleChangeExpanded = (panel) => (event, isExpanded) => {
    setExpanded((prevState) => ({
      ...prevState,
      [panel]: isExpanded,
    }));
  };
  const { userData } = useAuth();
  const [loding, setLoading] = useState(false);

  const [schema, setPerformanceSchema] = useState({
    employee_no: Yup.string().required("Employee No. is required"),
    DOB: Yup.string().required("DOB is required"),
    last_name: Yup.string().required("Last Name is required"),
    ssn: Yup.string()
      .required("SSN is required")
      .test(
        "len",
        "Must be exactly 4 characters",
        (val) => val && val.toString().length === 4
      ),
  });

  const initialItem = {
    gender: "",
    employee_no: "",
    DOB: "",
    last_name: "",
    ssn: "",
    HealthVendor: "",
    healthPlan: "",
    UID: "",
    Employeetype: "",
    healthDeductionClass: "",
    subscriberId: "",
    id: "",
    amount: "",
    email: "",
    mailingAddress: "",
  };

  const onSubmit = (e) => {
    // API Calling
    setLoading(true);
  };
  const {
    values,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
  } = useFormik({
    initialValues: initialItem,
    validationSchema: Yup.object().shape(schema),
    onSubmit,
  });

  const getDependentList = async (employeeId) => {
    axios
      .get(
        `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsMASTER/GetBySubscriberId?SubscriberId=${employeeId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
            Role: getUserRole(userData),
          },
        }
      )
      .then((response) => {
        let finalResponse = response.data;
        let basicInfo = finalResponse.filter(
          (i) => i.employeeId == i.subscriberId
        )?.[0];
        // let finalSetValue = {
        //   // applicant_name: basicInfo?.firstName,
        //   email: basicInfo?.email,
        //   street_address: basicInfo?.mailingAddress,
        //   city: basicInfo?.city,
        //   state: basicInfo?.state,
        //   zip: basicInfo?.zip,
        //   gender: basicInfo?.gender,
        //   // birthplace:basicInfo?.,
        //   Applicantssn: basicInfo?.ssn,
        //   work_phone: basicInfo?.workPhone,
        //   homePhone: basicInfo?.homePhone,
        //   firstName: basicInfo?.firstName,
        //   DOB: basicInfo?.dob ? moment(basicInfo?.dob).format("YYYY-MM-DD") : "",
        //   Date_Hire: basicInfo?.dateOfEmployment
        //     ? moment(basicInfo?.dateOfEmployment).format("YYYY-MM-DD")
        //     : "",
        //   social_security_number: basicInfo?.ssn ? basicInfo?.ssn : "",
        // };

        setValues((state) => {
          return {
            ...state,
            ...(!state.applicant_name && { applicant_name: basicInfo?.firstName }),
            ...(!state.email && { email: basicInfo?.email }),
            ...(!state.street_address && { street_address: basicInfo?.mailingAddress }),
            ...(!state.city && { city: basicInfo?.city }),
            ...(!state.state && { state: basicInfo?.state }),
            ...(!state.zip && { zip: basicInfo?.zip }),
            ...(!state.Applicantssn && { Applicantssn: basicInfo?.ssn }),
            ...(!state.work_phone && { work_phone: basicInfo?.workPhone }),
            ...(!state.homePhone && { homePhone: basicInfo?.homePhone }),
            ...(!state.firstName && { firstName: basicInfo?.firstName }),
            ...(!state.DOB && { DOB: basicInfo?.DOB ? moment(basicInfo?.dob).format("YYYY-MM-DD") : null }),
            ...(!state.Date_Hire && { Date_Hire: basicInfo?.dateOfEmployment ? moment(basicInfo?.dateOfEmployment).format("YYYY-MM-DD") : null }),
          };
        });
      })
      .catch((error) => {
        console.warn("Cannot retrieve user data", error);
      });
  };

  useEffect(() => {
    getDependentList(EmployeeId);
  }, []);

  const useTogglePassword = (initialType = "password") => {
    const [showPassword, setShowPassword] = useState(false);
    const [type, setType] = useState(initialType);

    const handleTogglePassword = () => {
      setShowPassword(!showPassword);
      setType((prevType) => (prevType === "password" ? "text" : "password"));
    };

    return { showPassword, type, handleTogglePassword };
  };

  function renderTextInput(stateName, label, others = {}, toggleIcon = null) {
    let {
      disabled = false,
      maxLength = "",
      multiline = false,
      required = false,
      shrink = true,
      type = "text", // Default type is text
      ...otherProps
    } = others;

    const handleInputChange = (e) => {
      if (!disabled) {
        const { value } = e.target;
        if (type === "number" && maxLength && value.length > maxLength) {
          e.target.value = value.slice(0, maxLength); // Trim input to maxLength for number types
        }
        handleChange(e);
      }
    };

    return (
      <TextField
        fullWidth
        size="small"
        inputProps={{
          style: {
            fontSize: "14px",
            paddingTop: "12px",
            width: "100%",
          },
          readOnly: disabled,
          maxLength: type === "number" ? null : maxLength, // Apply maxLength only for non-number types
          ...otherProps, // Spread otherProps to inputProps
        }}
        margin="dense"
        variant="outlined"
        label={label}
        name={stateName}
        id={stateName}
        multiline={multiline}
        rows={multiline ? 3 : 1}
        value={values[stateName] || lifevalues[stateName] || ""}
        InputLabelProps={{
          shrink: shrink ? shrink : false,
          classes: { asterisk: required ? classes.asterisk : false },
        }}
        // InputLabelProps={{ shrink: shrink ? shrink : false }}
        shrink={shrink ? "true" : "false"}
        onChange={handleInputChange}
        // onBlur={handleBlur}
        error={!disabled && touched[stateName] && errors[stateName]}
        helperText={
          !required && !disabled && touched[stateName] && errors[stateName]
        }
        disabled={disabled}
        required={required}
        type={type} // Pass type directly to TextField
        InputProps={{
          endAdornment: toggleIcon,
        }}
      />
    );
  }

  const ssnToggle1 = useTogglePassword("password");
  const ssnToggle2 = useTogglePassword("password");

  function renderDateInput(
    stateName,
    label,
    disabled = false,
    minDate = null
    // maxDate
  ) {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker
          inputVariant={"outlined"}
          margin="dense"
          format="MM/dd/yyyy"
          label={label}
          minDate={minDate}
          // maxDate={maxDate}
          value={values[stateName] ? values[stateName] : null}
          KeyboardButtonProps={{ "aria-label": label }}
          disabled={disabled}
          onChange={(value) => {
            const formatDate = value?.$d;
            const date = formatDate
              ? moment(formatDate).format("YYYY-MM-DD hh:mm:ss")
              : null;
            // setShow(false);
            setFieldValue(stateName, date);
          }}
          onBlur={handleBlur}
          renderInput={(params) => (
            <TextField
              fullWidth
              margin="dense"
              size="small"
              InputLabelProps={{ shrink: true }}
              {...params}
              error={!disabled && errors[stateName]}
              helperText={!disabled && errors[stateName]}
            />
          )}
        />
      </LocalizationProvider>
    );
  }

  const setAmount = (currentClass) => {
    let getAmount = companyArray
      .find((item) => item.vendor_name == values?.HealthVendor)
      ?.vendor_items.find((item) => item.vendor_code == values?.healthPlan)
      ?.classInfo.find((ite) => ite.value == currentClass)?.amount;
    setFieldValue("amount", getAmount);
  };

  const verifyValidation = (values) => {
    let errors = {};
    if (!values.name_of_group) {
      errors.name_of_group = "Name of Group is required";
    }
    if (!values.group_number) {
      errors.group_number = "Group Number is required";
    }
    if (!values.firstName) {
      errors.firstName = "member/employee Name is required";
    }
    if (!values.occupation) {
      errors.occupation = "occupation is required";
    }
    if (!values.social_security_number) {
      errors.social_security_number = "Social Security Number is required";
    }
    if (!values.applicant_name) {
      errors.applicant_name = "Applicant name is required";
    }
    if (!values.email) {
      errors.email = "Email Address is required";
    }
    if (!values.street_address) {
      errors.street_address = "Street Address is required";
    }
    if (!values.city) {
      errors.city = "City is required";
    }
    if (!values.state) {
      errors.state = "State/Province is required";
    }
    if (!values.zip) {
      errors.zip = "Zip/Postal code is required";
    }
    if (!values.birthplace) {
      errors.birthplace = "Birthplace is required";
    }
    if (!values.social_security_number) {
      errors.social_security_number = "Social Security Number is required";
    }
    if (!values.work_phone) {
      errors.work_phone = "Work Phone is required";
    }
    if (!values.homePhone) {
      errors.homePhone = "Home Phone is required";
    }
    if (!values.doctor_first_name) {
      errors.doctor_first_name = "Doctor first name  is required";
    }
    if (!values.doctor_last_name) {
      errors.doctor_last_name = "Doctor Last name  is required";
    }
    if (!values.clinic_name) {
      errors.clinic_name = "Clinic name  is required";
    }
    if (!values.doctor_phone) {
      errors.doctor_phone = "Doctor Phone Number  is required";
    }
    if (!values.doctor_address) {
      errors.doctor_address = "Doctor Address  is required";
    }
    if (!values.doctor_city) {
      errors.doctor_city = "City  is required";
    }
    if (!values.doctor_state_province) {
      errors.doctor_state_province = "State/province  is required";
    }
    if (!values.doctor_zip_code) {
      errors.doctor_zip_code = "Zip/Postal code is required";
    }
    if (!values.height) {
      errors.height = "height is required";
    }
    if (!values.Weight) {
      errors.Weight = "Weight is required";
    }

    if (selectedValues.length === 0) {
      errors.checkboxlife =
        "Check the type and provide details for Life and Dependents Life";
    }
    if (!values.current_amount_in_Force1 && selectedValues.length !== 0 && values.Life == "Life") {
      errors.current_amount_in_force = "Current Amout in force is required";
    }
    if (!values.current_amount_in_Force2 && selectedValues.length !== 0 && values.DependentsLife == "DependentsLife") {
      errors.current_amount_in_force2 = "Current Amout in force is required";
    }
    if (!values.additional_amount_requested1 && selectedValues.length !== 0 && values.Life == "Life") {
      errors.additional_amount_requested =
        "Additional Amount Requested is required";
    }
    if (!values.additional_amount_requested2 && selectedValues.length !== 0 && values.DependentsLife == "DependentsLife") {
      errors.additional_amount_requested2 =
        "Additional Amount Requested is required";
    }
    if (!values.total_amount_requested1 && selectedValues.length !== 0 && values.Life == "Life") {
      errors.total_amount_requested1 = "Total Amount Requested is required";
    }
    if (!values.total_amount_requested2 && selectedValues.length !== 0 && values.DependentsLife == "DependentsLife") {
      errors.total_amount_requested2 = "Total Amount Requested is required";
    }
    return errors;
  };



  const getBenefitLifeInsurance = () => {
    setLoading(true)
    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;

    const payload = {
      tableName: "sp_get_benefit_lifeInsurance_for_admin",
      SearchParams: `[{"columnName":"SubID","operator":"=","value":'${EmployeeId}',"dataType":"VARCHAR"}]`,
      columns: "*",
      pageNumber: 1,
      pageSize: 10000000,
      orderBy: "ID DESC",
      sortBy: "",
      orderByMultiple: "",
      limit: 10000000000,
      sortData: "",
      additionalWhere: "",
    };
    axios
      .post(`${newBaseURL}/BenefitAdvanceSearch/Benefits-global`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          Role: getUserRole(userData),
        },
      })
      .then((response) => {
        let finalResponse = response.data.results[0];
        const finalSetValue = {
          id: finalResponse?.ID ? finalResponse?.ID : null,
          doctor_first_name: finalResponse?.DrFirstName,
          doctor_last_name: finalResponse?.DrLastName,
          doctor_phone: finalResponse?.DrPhone,
          doctor_address: finalResponse?.ClinicAddress,
          date_last_consulted: finalResponse?.LastConsultedDate
            ? moment(finalResponse?.LastConsultedDate).format("YYYY-MM-DD")
            : "",
          reason_last_consulted: finalResponse?.ReasonLastConsulted,
          doctor_city: finalResponse?.DrCity,
          doctor_state_province: finalResponse?.DrState,
          doctor_zip_code: finalResponse?.DrZip,
          height: finalResponse?.Height,
          Weight: finalResponse?.Weight,
          clinic_name: finalResponse?.ClinicName,
          name_of_group: finalResponse?.NameOfGroup,
          WhoIsApplied: finalResponse?.WhoIsApplied,
          group_number: finalResponse?.Groupno,
          typeofApplication: finalResponse?.TypeofApplication,
          // new Added 

          ...(finalResponse?.med_emp_name && { firstName: finalResponse?.med_emp_name }),
          ...(finalResponse?.med_emp_dob && { DOB: finalResponse?.med_emp_dob }),
          ...(finalResponse?.med_emp_doh && { Date_Hire: finalResponse?.med_emp_doh }),
          occupation: finalResponse?.med_emp_occupation,
          ...(finalResponse?.med_emp_ssn && { social_security_number: finalResponse?.med_emp_ssn }),

          ...(finalResponse?.med_apl_name && { applicant_name: finalResponse?.med_apl_name }),
          ...(finalResponse?.med_apl_email && { email: finalResponse?.med_apl_email }),
          ...(finalResponse?.med_apl_street && { street_address: finalResponse?.med_apl_street }),
          ...(finalResponse?.med_apl_city && { city: finalResponse?.med_apl_city }),
          ...(finalResponse?.med_apl_state && { state: finalResponse?.med_apl_state }),
          ...(finalResponse?.med_apl_zip && { zip: finalResponse?.med_apl_zip }),
          ...(finalResponse?.med_apl_gender && { gender: finalResponse?.med_apl_gender }),
          ...(finalResponse?.med_apl_dob && { ApplicantDOB: finalResponse?.med_apl_dob }),
          ...(finalResponse?.med_apl_birthplace && { birthplace: finalResponse?.med_apl_birthplace }),
          ...(finalResponse?.med_apl_ssn && { Applicantssn: finalResponse?.med_apl_ssn }),
          ...(finalResponse?.med_apl_home_phone && { homePhone: finalResponse?.med_apl_home_phone }),
          ...(finalResponse?.med_apl_work_phone && { work_phone: finalResponse?.med_apl_work_phone }),

          med_app_life: finalResponse?.med_app_life ? "M" : "",
          med_app_amount: finalResponse?.med_app_amount,
          med_app_add_amount: finalResponse?.med_app_add_amount,
          med_app_total_amount: finalResponse?.med_app_total_amount,

          med_app_depe_life: finalResponse?.med_app_depe_life ? "D" : "",
          med_app_depe_amount: finalResponse?.med_app_depe_amount,
          med_app_depe_add_amount: finalResponse?.med_app_depe_add_amount,
          med_app_depe_total_amount: finalResponse?.med_app_depe_total_amount,

          doctor_address: finalResponse?.DrAddress,

          med_employeeSign: finalResponse?.med_employeeSign,
          med_employeeSignDate: finalResponse?.med_employeeSignDate


        };

        let selectedcheck = []

        if (finalResponse?.med_app_life) {
          selectedcheck.push('M')
        }

        if (finalResponse?.med_app_depe_life) {
          selectedcheck.push('D')
        }

        // console.log("sdkfjksdjfk", selectedcheck)
        setSelectedValues(selectedcheck)

        setValues((state) => {
          return { ...state, ...finalSetValue };
        });

        let absentCheckboxes = isJsonArrayString(finalResponse.MedicalStatementsAns)
        setAbsentCheckbox(absentCheckboxes)
      })
      .catch((error) => {
        console.warn("Cannot retrieve user data", error);
      }).finally(() => {
        setLoading(false)
      })
  };

  useEffect(() => {
    getBenefitLifeInsurance();
  }, []);

  const handleSubmitData = (event) => {
    if (event) event.preventDefault();
    let finalErrors = verifyValidation(values);
    setErrors(finalErrors);
    if (Object.keys(finalErrors)?.length) {
      ShowError("Please validate form")
      return;
    }
    setLoading(true)
    const payload = {
      subscriberId: EmployeeId,
      TypeofApplication: selectedValue,
      DrFirstName: values?.doctor_first_name,
      DrLastName: values?.doctor_last_name,
      DrPhone: values?.doctor_phone,
      clinicAddress: values?.doctor_address,
      LastConsultedDate: values?.date_last_consulted
        ? moment(values?.date_last_consulted).format("YYYY-MM-DD")
        : "",
      ReasonLastConsulted: values?.reason_last_consulted,
      DrCity: values?.doctor_city,
      DrState: values?.doctor_state_province,
      DrZip: values?.doctor_zip_code,
      Height: values?.height,
      Weight: values?.Weight,
      clinicName: values?.clinic_name,
      medicalStatementsAns: JSON.stringify(absentCheckbox),
      whoIsApplied: values?.WhoIsApplied,
      nameOfGroup: values?.name_of_group,
      typeofApplication: values?.typeofApplication,
      // "lifeAdditionalBeneficiary": "string",
      // "lifeDependentBeneficiary": "string"

      medEmpName: values?.firstName,
      medEmpDob: '2024-08-16T06:40:17.733Z',
      medEmpDoh: '2024-08-16T06:40:17.733Z',
      medEmpOccupation: values?.occupation,
      medEmpSsn: values?.social_security_number,

      medAplName: values?.applicant_name,
      medAplEmail: values?.email,
      medAplStreet: values?.street_address,
      medAplCity: values?.city,
      medAplState: values?.state,
      medAplZip: values?.zip,
      medAplGender: values?.gender,
      medAplDob: values?.ApplicantDOB,
      medAplBirthplace: values?.birthplace,
      medAplSsn: values?.Applicantssn,
      medAplHomePhone: values?.homePhone,
      medAplWorkPhone: values?.work_phone,

      medAppLife: values?.med_app_life ? true : false,
      medAppAmount: values?.med_app_amount,
      medAppAddAmount: values?.med_app_add_amount,
      medAppTotalAmount: values?.med_app_total_amount,

      medAppDepeLife: values?.med_app_depe_life ? true : false,
      medAppDepeAmount: values?.med_app_depe_amount,
      medAppDepeAddAmount: values?.med_app_depe_add_amount,
      medAppDepeTotalAmount: values?.med_app_depe_total_amount,

      drAddress: values?.doctor_address,

      medEmployeeSign: values?.med_employeeSign,
      medEmployeeSignDate: values?.med_employeeSignDate,

    };

    let createAPI = `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsLifeInsurance/create`;

    if (values.id) {
      let UpdateAPI = `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsLifeInsurance/update`;
      payload.id = values.id;
      axios
        .put(UpdateAPI, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          },
        })
        .then((res) => {
          console.log("updatecoverage", res);
          ShowSucess(res.data);
          getBenefitLifeInsurance();
        })
        .catch((err) => {
          console.log("updatecoverage", err);
        }).finally(() => {
          setLoading(false);
        })
    } else {
      axios
        .post(createAPI, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          },
        })
        .then((res) => {
          ShowSucess(res.data);
          getBenefitLifeInsurance();
        })
        .catch((err) => {
          console.log("updatecoverage", err);
        }).finally(() => {
          setLoading(false);
        })
    }
  };


  return (
    <Fragment>
      {loding && loadingPanel()}
      <Container fluid={true} className="updView">
        <Row className="bg-primary rounded m-0 p-0 py-1 mb-3 ">
          <Typography variant="h5">
            <Row>
              <Icon style={{ fontSize: "25px", margin: "10px" }} name="graph" />
              <Col>
                <div>
                  Standard Insurance Company - Government of Guam Medical
                  History Statement
                </div>
                <p style={{ fontSize: "11px" }}>
                  Medical Underwriting, 900 SW Fifth Avenue Portland OR 97204
                </p>
              </Col>
            </Row>
          </Typography>
        </Row>
        {/* DIRECTIONS button */}
        <Card
          style={{
            marginTop: "10px",
            padding: "10px",
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Col>
            <b>DIRECTIONS FOR APPLYING FOR COVERAGE</b>
            <p style={{ fontSize: "12px" }}>
              Read the Information Practices Notice(s) on page 4. A separate
              fonn must be submitted for each applicant (Employee/Member, Spouse
              and/or Child) when Evidence Of lnsurabllity or Proof of Good
              Health is required to apply for coverage. Complete all items, date
              and sign in the space at the bottom of page 3. Keep a copy for
              your records, and send the original to Standard Insurance Company
              at the address given above.
            </p>
          </Col>
        </Card>
        {/* End of DIRECTIONS details */}
        {/* submit button */}
        <Card
          style={{
            marginTop: "10px",
            padding: "10px",
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Button
            onClick={(e) => handleSubmitData()}
            style={{ color: "white" }}
            variant="fill"
            className="btn btn-primary"
          >
            Update Medical Report
          </Button>
        </Card>
        {/* MEMBER/EMPLOYEE INFORMATION details */}
        <Card style={{ marginTop: "10px" }}>
          <Accordion
            className={classes.root}
            expanded={expanded.memInfo}
            onChange={handleChangeExpanded("memInfo")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2bh-content"
              id="panel2bh-header"
              className="sub-header w-100 p-1 bg-primary text-white"
              style={{ width: "100%" }}
            >
              <FontAwesomeIcon
                icon={faRectangleList}
                className="sub-header"
                style={{
                  // color: "#1569C7",
                  marginRight: "10px",
                  marginTop: "3px",
                }}
              />
              <Typography
                className={classes.heading}
                style={{ height: "auto" }}
              >
                MEMBER/EMPLOYEE INFORMATION
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="p-0 page-body-wrapper">
              <Card style={{ padding: "20px" }}>
                <Row>
                  <Col md={3}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput("name_of_group", `Name of Group`, {
                        maxLength: 50,
                        required: true,
                        type: "text",
                      })}
                    </div>
                    <Errorlable text={errors.name_of_group} />
                  </Col>
                  <Col md={3}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput("group_number", "Group Number", {
                        maxLength: 10,
                        required: true,
                        type: "number",
                      })}
                    </div>
                    <Errorlable text={errors.group_number} />
                  </Col>
                  {/* <Col md={2}>{renderDateInput("DOB", "DOB")}</Col> */}

                  <Col
                    md={6}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <b style={{ marginLeft: "10px", fontSize: "12px" }}>
                      <p>Check who is Applying (One per form)</p>
                    </b>
                    <div>
                      {plan.Applying.map((i) => {
                        return (
                          <span
                            style={{ display: "inline-block" }}
                            key={i.value}
                          >
                            <Checkbox
                              size={"medium"}
                              value={i.value}
                              checked={values?.WhoIsApplied === i.value}
                              onChange={() => setValues({ ...values, WhoIsApplied: i.value })}
                            />
                            {i.label}
                          </span>
                        );
                      })}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput("firstName", "Member/Employee Name", {
                        required: true,
                      })}
                    </div>
                    <Errorlable text={errors.firstName} />
                  </Col>
                  <Col md={3}>{renderDateInput("DOB", "Birth Date")}</Col>
                  <Col md={3}>{renderDateInput("Date_Hire", "Date Hired")}</Col>
                  {/* <Col md={2}>{renderTextInput("classification", "Zip")}</Col> */}
                </Row>
                <Row>
                  <Col md={6}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput("occupation", "Occupation", {
                        required: true,
                      })}
                    </div>
                    <Errorlable text={errors.occupation} />
                  </Col>
                  <Col md={6}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput(
                        "social_security_number",
                        "Social Security Number",
                        {
                          maxLength: 20,
                          required: true,
                          type: ssnToggle1.type,
                        }, // Use toggle state for type
                        <IconButton
                          aria-label="toggle password visibility"
                          edge="end"
                          onClick={ssnToggle1.handleTogglePassword} // Use specific handler
                        >
                          {ssnToggle1.showPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      )}
                    </div>
                    <Errorlable text={errors.social_security_number} />
                  </Col>
                </Row>
              </Card>
            </AccordionDetails>
          </Accordion>
        </Card>
        {/* End of MEMBER/EMPLOYEE INFORMATION details */}
        {/* APPLICANT INFORMATION  details */}
        <Card style={{ marginTop: "10px" }}>
          <Accordion
            className={classes.root}
            expanded={expanded.applicantInfo}
            onChange={handleChangeExpanded("applicantInfo")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2bh-content"
              id="panel2bh-header"
              className="sub-header w-100 p-1 bg-primary text-white"
              style={{ width: "100%" }}
            >
              <FontAwesomeIcon
                icon={faRectangleList}
                className="sub-header"
                style={{
                  // color: "#1569C7",
                  marginRight: "10px",
                  marginTop: "3px",
                }}
              />
              <Typography
                className={classes.heading}
                style={{ height: "auto" }}
              >
                APPLICANT INFORMATION
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="p-0 page-body-wrapper">
              <Card style={{ padding: "20px" }}>
                <Row>
                  <Col md={6}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput(
                        "applicant_name",
                        "Applicant's Name (Person to be insured)",
                        { required: true }
                      )}
                    </div>
                    <Errorlable text={errors.firstName} />
                  </Col>
                  <Col md={6}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput("email", "Email Address", {
                        required: "true",
                      })}
                    </div>
                    <Errorlable text={errors.email} />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput("street_address", "Street Address", {
                        required: "true",
                      })}
                    </div>
                    <Errorlable text={errors.street_address} />
                  </Col>
                  <Col md={2}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput("city", "City", { required: "true" })}
                    </div>
                    <Errorlable text={errors.city} />
                  </Col>
                  <Col md={2}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput("state", "State/Province", {
                        required: "true",
                      })}
                    </div>
                    <Errorlable text={errors.state} />
                  </Col>
                  <Col md={2}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput("zip", "ZIP/Postal Code", {
                        required: "true",
                      })}
                    </div>
                    <Errorlable text={errors.zip} />
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <div>
                      {plan.Zender.map((i) => {
                        return (
                          <span
                            style={{ display: "inline-block" }}
                            key={i.value}
                          >
                            <Checkbox
                              size={"medium"}
                              value={values?.gender ? values?.gender : null}
                              checked={values?.gender === i.value}
                              onChange={() =>
                                setValues({ ...values, gender: i.value })
                              }
                            />
                            {i.label}
                          </span>
                        );
                      })}
                    </div>
                  </Col>
                  <Col md={3}>{renderDateInput("ApplicantDOB", "Birth Date")}</Col>
                  <Col md={3}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput("birthplace", "Birthplace", {
                        required: "true",
                      })}
                    </div>
                    <Errorlable text={errors.birthplace} />
                  </Col>
                  <Col md={3}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput(
                        "Applicantssn",
                        "Social Security Number",
                        {
                          maxLength: 20,
                          required: true,
                          type: ssnToggle2.type,
                        }, // Use toggle state for type
                        <IconButton
                          aria-label="toggle password visibility"
                          edge="end"
                          onClick={ssnToggle2.handleTogglePassword} // Use specific handler
                        >
                          {ssnToggle2.showPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      )}
                    </div>
                    <Errorlable text={errors.Applicantssn} />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput("work_phone", "Work Phone", {
                        required: "true",
                        type: "number",
                        maxLength: 12,
                      })}
                    </div>
                    <Errorlable text={errors.work_phone} />
                  </Col>
                  <Col md={6}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput("homePhone", "Home Phone", {
                        required: "true",
                        type: "number",
                        maxLength: 12,
                      })}
                    </div>
                    <Errorlable text={errors.homePhone} />
                  </Col>
                </Row>
              </Card>
            </AccordionDetails>
          </Accordion>
        </Card>
        {/* End of APPLICANT INFORMATION  details */}
        {/* APPLICANT INFORMATION  details */}
        <Card style={{ marginTop: "10px" }}>
          <Accordion
            className={classes.root}
            expanded={expanded.appInfo}
            onChange={handleChangeExpanded("appInfo")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2bh-content"
              id="panel2bh-header"
              className="sub-header w-100 p-1 bg-primary text-white"
              style={{ width: "100%" }}
            >
              <FontAwesomeIcon
                icon={faRectangleList}
                className="sub-header"
                style={{
                  // color: "#1569C7",
                  marginRight: "10px",
                  marginTop: "3px",
                }}
              />
              <Typography
                className={classes.heading}
                style={{ height: "auto" }}
              >
                APPLICATION INFORMATION
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="p-0 page-body-wrapper">
              <Card style={{ padding: "20px" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <b>Type of Application (check one)</b>
                  <div>
                    {plan.Application.map((i) => {
                      return (
                        <span style={{ display: "inline-block" }} key={i.value}>
                          <Checkbox
                            size={"medium"}
                            value={i.value}
                            checked={values?.typeofApplication === i.value}
                            onChange={() => handleCheckboxChange(i.value)}
                          />
                          {i.label}
                        </span>
                      );
                    })}
                  </div>
                </div>
                <div style={{ marginLeft: "12px" }}>
                  <b>
                    Check the type and provide details on the amount of coverage
                    you are requesting.
                  </b>
                </div>
                <div style={{ marginLeft: "15px" }}>
                  <Errorlable text={errors.checkboxlife} />
                </div>
                <div style={{ marginTop: "10px" }}>
                  <div>
                    {plan.Application_life.map((i) => (
                      <Row key={i.value} style={{ marginTop: "7px" }}>
                        <Col md={3} style={{ display: "inline-block" }}>
                          <Checkbox
                            size={"medium"}
                            value={i.value}
                            checked={selectedValues.includes(i.value)}
                            onChange={() =>
                              handleCheckboxLifeChange(
                                i.value,
                                i.currentamount,
                                i.additionalamount,
                                i.totalamount,
                                i.keyLabel
                              )
                            }
                          />
                          {i.label}
                        </Col>
                        <Col md={3}>
                          <div style={{ marginBlockEnd: "-4px" }}>
                            {renderTextInput(
                              i.currentamount,
                              "Current Amount in Force, if any",
                              {
                                disabled: !selectedValues.includes(i.value),
                                required: true,
                                type: "number",
                              }
                            )}
                          </div>
                          {i.value == selectedValues ||
                            selectedValues.length == 2 ? (
                            <div>
                              {i.value == "Life" ? (
                                <Errorlable
                                  text={errors.current_amount_in_force}
                                />
                              ) : (
                                <Errorlable
                                  text={errors.current_amount_in_force2}
                                />
                              )}
                            </div>
                          ) : (
                            <div></div>
                          )}
                        </Col>
                        <Col md={3}>
                          <div style={{ marginBlockEnd: "-4px" }}>
                            {renderTextInput(
                              i.additionalamount,
                              "Additional Amount Requested",
                              {
                                disabled: !selectedValues.includes(i.value),
                                required: true,
                                type: "number",
                              }
                            )}
                          </div>
                          {i.value == selectedValues ||
                            selectedValues.length == 2 ? (
                            <div>
                              {i.value == "Life" ? (
                                <Errorlable
                                  text={errors.additional_amount_requested}
                                />
                              ) : (
                                <Errorlable
                                  text={errors.additional_amount_requested2}
                                />
                              )}
                            </div>
                          ) : (
                            <div></div>
                          )}
                        </Col>
                        <Col md={3}>
                          <div style={{ marginBlockEnd: "-4px" }}>
                            {renderTextInput(
                              i.totalamount,
                              "Total Amount Requested",
                              {
                                disabled: !selectedValues.includes(i.value),
                                required: true,
                                type: "number",
                              }
                            )}
                          </div>
                          {i.value == selectedValues ||
                            selectedValues.length == 2 ? (
                            <div>
                              {i.value == "Life" ? (
                                <Errorlable
                                  text={errors.total_amount_requested1}
                                />
                              ) : (
                                <Errorlable
                                  text={errors.total_amount_requested2}
                                />
                              )}
                            </div>
                          ) : (
                            <div></div>
                          )}
                        </Col>
                      </Row>
                    ))}
                  </div>
                </div>

                {/* <Row>
                  <Col md={3}>
                    {renderCheckbox1(0, "medium", "workHr", "Yes")} Life
                  </Col>
                  <Col md={3}>
                      {renderTextInput(
                        "current_amount_in_Force",
                        "Current Amount in Force,if any",
                      )}   
                  </Col>
                  <Col md={3}>
                      {renderTextInput(
                        "additional_amount_requested",
                        "Additional Amount Requested",
                      )}
                  </Col>
                  <Col md={3}>
                      {renderTextInput(
                        "total_amount_requested",
                        "Total Amount Requested",
                      )}
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    {renderCheckbox1(0, "medium", "workHr", "Yes")} Dependents
                    Life
                  </Col>
                  <Col md={3}>
                      {renderTextInput(
                        "current_amount_in_Force",
                        "Current Amount in Force,if any",
                        
                      )}
                  </Col>
                  <Col md={3}>
                      {renderTextInput(
                        "additional_amount_requested",
                        "Additional Amount Requested",
                      )}
                  </Col>
                  <Col md={3}>
                      {renderTextInput(
                        "total_amount_requested",
                        "Total Amount Requested",
                      )}     
                  </Col>
                </Row> */}
              </Card>
            </AccordionDetails>
          </Accordion>
        </Card>
        {/* End of APPLICANT INFORMATION  details */}
        {/* PHYSICIAN INFORMATION  details */}
        <Card style={{ marginTop: "10px" }}>
          <Accordion
            className={classes.root}
            expanded={expanded.phyInfo}
            onChange={handleChangeExpanded("phyInfo")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2bh-content"
              id="panel2bh-header"
              className="sub-header w-100 p-1 bg-primary text-white"
              style={{ width: "100%" }}
            >
              <FontAwesomeIcon
                icon={faRectangleList}
                className="sub-header"
                style={{
                  // color: "#1569C7",
                  marginRight: "10px",
                  marginTop: "3px",
                }}
              />
              <Typography
                className={classes.heading}
                style={{ height: "auto" }}
              >
                PHYSICIAN INFORMATION
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="p-0 page-body-wrapper">
              <Card style={{ padding: "20px" }}>
                <Row>
                  <Col md={6}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput(
                        "doctor_first_name",
                        "Doctor First Name",
                        { required: "true" }
                      )}
                    </div>
                    <Errorlable text={errors.doctor_first_name} />
                  </Col>
                  <Col md={6}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput(
                        "doctor_last_name",
                        "Doctor Last Name ",
                        { required: "true" }
                      )}
                    </div>
                    <Errorlable text={errors.doctor_last_name} />
                  </Col>
                </Row>
                <Row>
                  <Col md={8}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput("clinic_name", "Clinic Name ", {
                        required: "true",
                      })}
                    </div>
                    <Errorlable text={errors.clinic_name} />
                  </Col>
                  <Col md={4}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput("doctor_phone", "Doctor Phone", {
                        required: "true",
                        type: "number",
                        maxLength: 12,
                      })}
                    </div>
                    <Errorlable text={errors.doctor_phone} />
                  </Col>
                </Row>
                <Row>
                  <Col md={5}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput("doctor_address", "Doctor Address", {
                        required: "true",
                      })}
                    </div>
                    <Errorlable text={errors.doctor_address} />
                  </Col>
                  <Col md={3}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput("doctor_city", "City", {
                        required: "true",
                      })}
                    </div>
                    <Errorlable text={errors.doctor_city} />
                  </Col>
                  <Col md={2}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput(
                        "doctor_state_province",
                        "State/Province",
                        { required: "true" }
                      )}
                    </div>
                    <Errorlable text={errors.doctor_state_province} />
                  </Col>
                  <Col md={2}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput("doctor_zip_code", "ZIP/Postal Code", {
                        required: "true",
                      })}
                    </div>
                    <Errorlable text={errors.doctor_zip_code} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    {renderDateInput(
                      "date_last_consulted",
                      "Date Last Consulted"
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput(
                        "reason_last_consulted",
                        "Reason Last Consulted"
                      )}
                    </div>
                    <Errorlable text={errors.doctor_zip_code} />
                  </Col>
                </Row>
                {/* <Row>
                  <Col md={6}>
                    {renderTextInput("Applicant Name", "Applicant Name")}
                  </Col>
                  <Col md={6}>
                    {renderTextInput(
                      "Social Security Number",
                      "Social Security Number"
                    )}
                  </Col>
                </Row> */}
              </Card>
            </AccordionDetails>
          </Accordion>
        </Card>
        {/* End of PHYSICIAN INFORMATION  details */}
        {/* PMEDICAL HISTORY STATEMENT QUESTIONS  details */}
        <Card style={{ marginTop: "10px" }}>
          <Accordion
            className={classes.root}
            expanded={expanded.medInfo}
            onChange={handleChangeExpanded("medInfo")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2bh-content"
              id="panel2bh-header"
              className="sub-header w-100 p-1 bg-primary text-white"
              style={{ width: "100%" }}
            >
              <FontAwesomeIcon
                icon={faRectangleList}
                className="sub-header"
                style={{
                  // color: "#1569C7",
                  marginRight: "10px",
                  marginTop: "3px",
                }}
              />
              <Typography
                className={classes.heading}
                style={{ height: "auto" }}
              >
                MEDICAL HISTORY STATEMENT QUESTIONS
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="p-0 page-body-wrapper">
              <Card style={{ padding: "20px" }}>
                <div>
                  <b>
                    Check yes or no for each of these questions, and give
                    details for any "yes" answers. Attach a separate sheet if
                    necessar
                  </b>
                  <div style={{ marginLeft: "15px" }}>
                    <Errorlable text={errors.checkboxvalue} />
                  </div>
                  <ol
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      marginTop: "5px",
                    }}
                  >
                    {medicaldata
                      ?.filter((p) => {
                        return p.ParentID === 0 && (p.ID === 1 || p.ID === 2);
                      })
                      .map((value) => {
                        return (
                          <div
                            key={value.ID}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Col md={10}>
                              <li>{value.Description}</li>
                            </Col>
                            <span style={{ textAlign: "center" }}>
                              <Checkbox
                                size={"medium"}
                                value="Y"
                                checked={isChecked(value.ID, 'Y')}
                                onChange={() =>
                                  handleCheckboxChanges(value.ID, "Y")
                                }
                              />
                              Yes
                            </span>
                            <span style={{ textAlign: "center" }}>
                              <Checkbox
                                size={"medium"}
                                value="N"
                                checked={isChecked(value.ID, 'N')}
                                onChange={() =>
                                  handleCheckboxChanges(value.ID, "N")
                                }
                              />
                              No
                            </span>
                          </div>
                        );
                      })}
                  </ol>
                  <ol
                    type="A"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    {medicaldata
                      ?.filter((p) => {
                        return p.ParentID === 2;
                      })
                      .map((value) => {
                        return (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              paddingLeft: "12px",
                            }}
                          >
                            <Col md={10}>
                              <li>{value.Description}</li>
                            </Col>
                            <span style={{ textAlign: "center" }}>
                              <Checkbox
                                size={"medium"}
                                value="Y"
                                checked={isChecked(value.ID, 'Y')}
                                onChange={() =>
                                  handleCheckboxChanges(value.ID, "Y")
                                }
                              />
                              Yes
                            </span>
                            <span style={{ textAlign: "center" }}>
                              <Checkbox
                                size={"medium"}
                                value="N"
                                checked={isChecked(value.ID, 'N')}
                                onChange={() =>
                                  handleCheckboxChanges(value.ID, "N")
                                }
                              />
                              No
                            </span>
                          </div>
                        );
                      })}
                  </ol>
                  <ol
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      marginTop: "5px",
                    }}
                    start="3"
                  >
                    {medicaldata
                      ?.filter((p) => {
                        return p.ParentID === 0 && p.ID !== 1 && p.ID !== 2;
                      })
                      .map((value) => {
                        return (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Col md={10}>
                              <li>{value.Description}</li>
                            </Col>
                            <span style={{ textAlign: "center" }}>
                              <Checkbox
                                size={"medium"}
                                value="Y"
                                checked={isChecked(value.ID, 'Y')}
                                onChange={() =>
                                  handleCheckboxChanges(value.ID, "Y")
                                }
                              />
                              Yes
                            </span>
                            <span style={{ textAlign: "center" }}>
                              <Checkbox
                                size={"medium"}
                                value="N"
                                checked={isChecked(value.ID, 'N')}
                                onChange={() =>
                                  handleCheckboxChanges(value.ID, "N")
                                }
                              />
                              No
                            </span>
                          </div>
                        );
                      })}
                  </ol>
                  <Row>
                    <Col md={6}>
                      <b>Height</b>
                      <div>
                        <div style={{ marginBlockEnd: "-4px" }}>
                          {renderTextInput("height", "", { required: "true" })}
                        </div>
                        <Errorlable text={errors.height} />
                      </div>
                    </Col>
                    <Col md={6}>
                      <b>Weight</b>
                      <div>
                        <div style={{ marginBlockEnd: "-4px" }}>
                          {renderTextInput("Weight", "", { required: "true" })}
                        </div>
                        <Errorlable text={errors.Weight} />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Card>
            </AccordionDetails>
          </Accordion>
        </Card>
        {/* End of MEDICAL HISTORY STATEMENT QUESTIONS  details */}
        {/* ACKNOWLEDGMENT AND AUTHORIZATION FOR RELEASE OF INFORMATION   details */}
        <Card style={{ marginTop: "10px" }}>
          <Accordion
            className={classes.root}
            expanded={expanded.ackInfo}
            onChange={handleChangeExpanded("ackInfo")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2bh-content"
              id="panel2bh-header"
              className="sub-header w-100 p-1 bg-primary text-white"
              style={{ width: "100%" }}
            >
              <FontAwesomeIcon
                icon={faRectangleList}
                className="sub-header"
                style={{
                  // color: "#1569C7",
                  marginRight: "10px",
                  marginTop: "3px",
                }}
              />
              <Typography
                className={classes.heading}
                style={{ height: "auto" }}
              >
                ACKNOWLEDGMENT AND AUTHORIZATION FOR RELEASE OF INFORMATION
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="p-0 page-body-wrapper">
              <Card style={{ padding: "20px" }}>
                <Col>
                  <ul
                    style={{
                      listStyleType: "disc",
                      marginLeft: "12px",
                      marginBottom: "10px",
                      fontSize: "13px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                      fontSize: "12px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "15px",
                      }}
                    >
                      <li>
                        I represent that the statements contained herein,
                        including those made in response to the Medical History
                        Statement questions and any supplemental information,
                        are true and complete to the best of my knowledge and
                        belief, and I understand that they form the basis of any
                        coverage under the Group Policy(ies). I understand that
                        any misstatements or failure to report information which
                        is material to the issuance of coverage may be used as a
                        basis for rescission of my insurance and/or denial of
                        payment of a claim. I agree to notify Standard Insurance
                        Company (The Standard) of any change in my medical
                        condition while my enrollment application is pending. I
                        agree that if my application is approved by The
                        Standard, the effective date of any coverage will be
                        determined in accordance with the terms of the Group
                        Policy(ies), including any applicable Active Work
                        requirement. I agree that if my application is declined,
                        The Standard's liability is limited to the return of any
                        premium which may have been paid.
                      </li>
                      <li>
                        To any health plan, physician, health care provider,
                        hospital, clinic, laboratory, pharmacy, pharmacy benefit
                        manager, medical facility, insurance or reinsurance
                        company, and the M 18, Inc. (MIB), I instruct you to
                        disclose my entire medical record and any other
                        protected health information concerning me to The
                        Standard or its reinsurers. This includes information on
                        any disorder of the immune system, including Acquired
                        Immune Deficiency Syndrome (AIDS) or other related
                        syndromes or complexes, and any communicable or sexually
                        transmitted disease or disorder. This also includes
                        information on the diagnosis and treatment of mental
                        illness and the use of alcohol, drugs, and tobacco, but
                        excludes psychotherapy notes.
                      </li>
                      <li>
                        By my signature below, I acknowledge that any agreements
                        I have made to restrict my protected health information
                        do not apply to this authorization and I instruct any of
                        the above to release and disclose my entire medical
                        records without restriction.
                      </li>
                      <li>
                        I understand that The Standard will use information to
                        determine my eligibility for group insurance coverage. I
                        understand The Standard may release information it has
                        about me to its reinsurers and to any person performing
                        business or legal services for The Standard in
                        connection with my application. I authorize The Standard
                        to release information it has about me to MIB for the
                        purpose of reporting to the MIB information exchange and
                        for MIB to audit The Standard's reporting. I understand
                        The Standard may release information it has about me to
                        other insurance companies to which I have applied for
                        insurance coverage or benefits.
                      </li>
                      <li>
                        I understand that information disclosed to The Standard
                        pursuant to authorization may be subject to redisclosure
                        with my authorization or as otherwise permitted by law.
                        Life and disability insurance coverages are not subject
                        to the Privacy Rule under the Health Insurance
                        Portability and Accountability Act (HIPAA), and
                        therefore release of information to The Standard is not
                        protected under the Act.
                      </li>
                      <li>
                        I understand that I am entitled to receive a copy of
                        this authorization. This authorization will remain valid
                        six months from the date of the signature below. A
                        photocopy or facsimile of this authorization shall be as
                        valid as the original.
                      </li>
                      <li>
                        I understand that I have the right to refuse to sign
                        this authorization. I further understand that I have a
                        right to revoke this authorization at any time by
                        sending a written statement to The Standard, except to
                        the extent it has been relied upon to disclose requested
                        records. I understand that the revocation of the
                        authorization, or the failure to sign the authorization,
                        may impair The Standard's ability to evaluate or process
                        my application and may be a basis for denying my
                        application for insurance coverage.
                      </li>
                      <li>
                        I understand that if my application is approved,
                        premiums shall be paid in accordance with the provisions
                        of the Group Policy(ies), and my coverage will be
                        subject to all terms and conditions of the Group
                        Policy(ies) and state limitations.
                      </li>
                      <li>
                        For Member/Employee: If I currently have a Life and/or
                        Trust Life beneficiary designation on file with my plan
                        administrator, I understand the designation(s) on file
                        will also apply to any approved amounts. If I have no
                        beneficiary designation(s) on file or I wish to change
                        the name of the current beneficiary(ies), I will contact
                        my plan administrator.
                      </li>
                      <li>
                        I understand that insurance on a Spouse or other
                        Dependent, if any, is payable to the Member/Employee, if
                        living, or as provided under the tenns of the Group
                        Policy(ies).
                      </li>
                      <li>
                        I acknowledge that I have read and received the
                        Information Practices Notice and Fraud Notice (if
                        applicable), and I have made a copy of this Medical
                        History Statement.
                      </li>
                    </div>
                  </ul>
                  <Row>
                    <Col md={6}>
                      <b>
                        Signature of Applicant (or Member/Employee for Dependent
                        Child)
                      </b>
                      <Col md={12}>
                        <div
                          style={{
                            background: "white",
                            border: "1px solid lightgray",
                            width: "100%",
                            marginTop: "6px",
                            height: "90px",
                            borderRadius: "5px",
                          }}
                        >
                          <small
                            style={
                              !true
                                ? {
                                  fontFamily: "Roboto,Helvetica,Arial,sans-serif",
                                  fontSize: "15px",
                                  top: "2px",
                                  color: "rgba(0, 0, 0, 0.38)",
                                  position: "sticky",
                                  display: "block",
                                  padding: "3px 6px",
                                }
                                : {
                                  fontFamily: "Roboto,Helvetica,Arial,sans-serif",
                                  fontSize: "15px",
                                  top: "2px",
                                  color: "rgba(0, 0, 0, 0.6)",
                                  position: "sticky",
                                  display: "block",
                                  padding: "3px 6px",
                                }
                            }
                          >
                            {"Signature of Applicant (or Member/Employee for Dependent Child)"}
                          </small>
                          {values?.med_employeeSign ? (
                            <img className={"sigImage"}
                              // src={removeAfterString(getValues(signature)?.trim(), '=sv')?.status ? removeAfterString(getValues(signature)?.trim(), 'sv=')?.newUrl : getValues(signature)?.trim()} 
                              src={values?.med_employeeSign}
                            />
                          ) : null}
                          <button
                            className="icon m-2 "
                            style={{
                              border: "none",
                              backgroundColor: "transparent",
                            }}
                            type="button"
                            onClick={(e) => {
                              setOpenCanvas(true);
                              // setStateOfSign(stateName);
                            }}
                          >
                            {true == false ? (
                              <FontAwesomeIcon
                                icon={faUpload}
                                size="lg"
                                style={{
                                  "--fa-primary-color": "#919191",
                                  "--fa-secondary-color": "#bababa",
                                }}
                              />
                            ) : (
                              <i class="fa-duotone fa-upload  fa-lg"></i>
                            )}
                          </button>
                        </div>
                      </Col>
                    </Col>
                    <Col md={6}>
                      <b>Date</b>
                      <div>{renderDateInput("med_employeeSignDate", "")}</div>
                    </Col>
                  </Row>
                </Col>
              </Card>
            </AccordionDetails>
          </Accordion>
        </Card>
        {/* End of ACKNOWLEDGMENT AND AUTHORIZATION FOR RELEASE OF INFORMATION  details */}
        {/* INFORMATION PRACTICES NOTICE    details */}
        {/* <Card style={{ marginTop: "10px" }}>
          <Accordion
            className={classes.root}
            expanded={expanded.empDetail}
            onChange={handleChangeExpanded("empDetail")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2bh-content"
              id="panel2bh-header"
              className="sub-header w-100 p-1 bg-primary text-white"
              style={{ width: "100%" }}
            >
              <FontAwesomeIcon
                icon={faRectangleList}
                className="sub-header"
                style={{
                  // color: "#1569C7",
                  marginRight: "10px",
                  marginTop: "3px",
                }}
              />
              <Typography
                className={classes.heading}
                style={{ height: "auto" }}
              >
                INFORMATION PRACTICES NOTICE
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="p-0 page-body-wrapper">
              <Card style={{ padding: "20px" }}>
                <Col>
                  <ul
                    style={{
                      listStyleType: "disc",
                      marginLeft: "12px",
                      marginBottom: "10px",
                      fontSize: "13px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                      fontSize: "12px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "15px",
                      }}
                    >
                      <li>
                        To help us determine your eligibility for group
                        insurance we may request information about you from
                        other persons and organizatios. For examle, we may
                        request infom1ation from your doctor or hospital, other
                        insurance companies, or MIB, Inc. (MIB), formerly known
                        as Medical lnfom1at1on Bureau. We will use the
                        authorization you signed on this form when we seek this
                        information.
                      </li>
                      <li>
                        Ml B-Information regarding your insurability will be
                        treated as confidential. Standard Insurance Company or
                        its reinsurers may, however, make a brief report thereon
                        to MIB, a not-for-profit membership organization of
                        insurance companies, which operates an information
                        exchange on behalf of its Members. If you apply to
                        another MIB Member company for life or health Oncluding
                        short and long term disability) insurance coverage, or a
                        claim for benefits is submitted to such a company, MIB,
                        upon request, will supply such company with the
                        information in its file. Upon receipt of a request from
                        you, MIB will arrange disclosure of any information it
                        may have in your file. Please contact MIB at 866-
                        692-6901. If you question the accuracy of information in
                        MIB's file, you may contact MIB and seek a correction in
                        accordance with the procedures set forth in the federal
                        Fair Credit Reporting Act. The address of MIB's
                        information office is: 50 Braintree Hill Park, Suite
                        400, Braintree, Massachusetts 02184-8734. Standard
                        Insurance Company may release information in its file to
                        its reinsurers, and Standard Insurance Company, or its
                        reinsurers, may release information in its file to other
                        insurance companies to whom you may apply for life or
                        health (including short and long term disability)
                        insurance, or to whom a claim for benefits may be
                        submitted. Information for consumers about MI B may be
                        obtained on its website at www.mib.com.
                      </li>
                      <li>
                        DISCLOSURE TO OTHERS- The information collected about
                        you is confidential. We will not release any information
                        about you without your authorization, except to the
                        extent necessary to conduct our business or as required
                        or permitted by law
                      </li>
                      <li>
                        YOUR RIGHTS - You have a right to know what information
                        we have about you in our undel"Nriting file. You also
                        have a right to ask us to correct any information you
                        think is incorrect. We will carefully review your
                        request and make changes when justified. If you would
                        like more information about this right or our
                        information practices please write to us at Medical
                        Unde1V1riting, Standard Insurance Company, 900 SW Fifth
                        Avenue, Portland, Oregon 97204 or call 1-800-843-7979.
                      </li>
                    </div>
                  </ul>
                </Col>
              </Card>
            </AccordionDetails>
          </Accordion>
        </Card> */}
        {/* INFORMATION PRACTICES NOTICE   details */}
        {/* FRAUD NOTICE     details */}
        {/* <Card style={{ marginTop: "10px" }}>
          <Accordion
            className={classes.root}
            expanded={expanded.empDetail}
            onChange={handleChangeExpanded("empDetail")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2bh-content"
              id="panel2bh-header"
              className="sub-header w-100 p-1 bg-primary text-white"
              style={{ width: "100%" }}
            >
              <FontAwesomeIcon
                icon={faRectangleList}
                className="sub-header"
                style={{
                  // color: "#1569C7",
                  marginRight: "10px",
                  marginTop: "3px",
                }}
              />
              <Typography
                className={classes.heading}
                style={{ height: "auto" }}
              >
                FRAUD NOTICE
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="p-0 page-body-wrapper">
              <Card style={{ padding: "20px" }}>
                <Col>
                  <ul
                    style={{
                      listStyleType: "disc",
                      marginLeft: "12px",
                      marginBottom: "10px",
                      fontSize: "13px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                      fontSize: "12px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "15px",
                      }}
                    >
                      <li>
                        ARKANSAS, MAINE, OHIO; Some states require us to inform
                        you that any person who knowingly and with intent to
                        injure, defraud or deceive an insurance company, or
                        other person, files a statement containing false or
                        misleading information concerning any fact material
                        hereto commits a fraudulent insurance act which is
                        subject to civil and/or criminal penalties, depending
                        upon the state. Such actions may be deemed a felony and
                        substantial fines may be imposed.
                      </li>
                      <li>
                        COLORADO: It is unlawful to knowingly provide false.
                        incomplete or misleading facts or information to an
                        insurance company for the purpose of defrauding or
                        attempting to defraud the company. Penalties may include
                        imprisonment, fines, denial of insurance, and civil
                        damages. Any insurance company or agent of an insurance
                        company who kindly provides false, incomplete, or
                        misleading facts or information to the policyholder or
                        claimant for the purpose of defrauding or attempting to
                        defraud the policyholder or claimant with regard to a
                        settlement or award payable from insurance proceeds
                        shall be reported to the Colorado division of insurance
                        within the department of regulatory agencies.
                      </li>
                      <li>
                        DISTRICT OF COLUMBIA: It is a crime to provide false or
                        misleading information to an insurer for the purpose of
                        defrauding the insurer or any other person. Penalties
                        include imprisonment and/or fines. In addition, an
                        insurer may deny insurance benefits if false information
                        materially related to a claim was provided by the
                        applicant.
                      </li>
                      <li>
                        KENTUCKY: Any person who knowingly and with intent to
                        defraud any insurance company or other person files an
                        application for insurance containing any materially
                        false information or conceals, for the purpose of
                        misleading, information concerning any fact material
                        thereto commits a fraudulent insurance act, which is a
                        crime.
                      </li>
                      <li>
                        LOUISIANA, NEW MEXICO: Any person who knowingly and
                        willfully presents a false or fraudulent claim for
                        payment of a loss or benefit or who knowingly and
                        willfully presents false information in an application
                        for insurance is guilty of a crime and may be subject to
                        fines and confinement in prison.
                      </li>
                      <li>
                        MARYLAND, RHODE ISLAND: Any person who knowingly or
                        willfully presents a false or fraudulent claim for
                        payment of a loss or benefit or who knowingly or
                        willfully presents false information in an application
                        for insurance is guilty of a crime and may be subject to
                        fines and confinement in prison.
                      </li>
                      <li>
                        NEW JERSEY: Any person who includes any false or
                        misleading information on an application for an
                        insurance policy is subject to criminal and civil
                        penalties.
                      </li>
                      <li>
                        NEW YORK; Any person who knowingly and with intent to
                        defraud any insuranc company or other person files an
                        application for insurance or statement of claim
                        containing any materially false information, or conceals
                        for the purpose of misleading, information concerning
                        any fact material thereto commits a fraudulent act,
                        which is a crime, and shall be subject to a civil
                        penalty not to exceed five thousand dollars and the
                        stated value of the claim for each such violation.
                      </li>
                      <li>
                        PENNSYLVANIA: Any person who knowingly and with intent
                        to defraud any insurance company or other person files
                        an application for insurance or statement of claim
                        containing any materially false information or conceals
                        for the purpose of misleading, information concerning
                        any fact material thereto commits a fraudulent insurance
                        act, which is a crime and subjects such person to
                        criminal and civil penalties.
                      </li>
                      <li>
                        PUERTO RICO: Any person who knowingly and with the
                        intention to defraud includes false information in an
                        application for insurance or file, assist or abet in the
                        filing of a fraudulent claim to obtain payment of a loss
                        or any other benefit, or files more than one claim for
                        the same loss or damage, commits a felony and if found
                        guilty shall be punished for each violation with a fine
                        of no less than five thousand dollars ($5,000), not to
                        exceed ten thousand dollars ($10,000); or imprisoned for
                        a fixed term of three (3) years, or both. If aggravating
                        circumstances exist, the fixed jail term may be
                        increased to a maximum of five (5) years; if mitigating
                        circumstances are present, the jail term may be reduced
                        to
                      </li>
                      <li>
                        TENNESSEE, VIRGINIA, WASHINGTON: It is a crime to
                        knowingly provide false, incomplete, or misleading
                        information to an insurance company for the purpose of
                        defrauding the company. Penalties include imprisonment,
                        fines, and denial of insurance benefits.
                      </li>
                    </div>
                  </ul>
                </Col>
              </Card>
            </AccordionDetails>
          </Accordion>
        </Card> */}
        {/* FRAUD NOTICE    details */}
        <NoticeDetail />
      </Container>
      <CoverageEmployeeSign
        openCanvas={openCanvas}
        closeCanvas={closeCanvas}
        values={values}
        // onBlurHandler={onBlurHandler}
        setValues={setValues}
        keyName={"med_employeeSign"}
      />
    </Fragment>
  );
};

export default CoverageMain;
